var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalleryicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8C11.25 8.41421 10.9142 8.75 10.5 8.75H1.5C1.08579 8.75 0.75 8.41421 0.75 8V3.5C0.75 3.08579 1.08579 2.75 1.5 2.75H2.37868C2.97542 2.75 3.54771 2.51295 3.96967 2.09099L4.59099 1.46967C4.73164 1.32902 4.92241 1.25 5.12132 1.25H6.87868C7.07759 1.25 7.26836 1.32902 7.40901 1.46967L8.03033 2.09099C8.45229 2.51295 9.02458 2.75 9.62132 2.75H10.5C10.9142 2.75 11.25 3.08579 11.25 3.5V8ZM1.5 2C0.671573 2 0 2.67157 0 3.5V8C0 8.82843 0.671573 9.5 1.5 9.5H10.5C11.3284 9.5 12 8.82843 12 8V3.5C12 2.67157 11.3284 2 10.5 2H9.62132C9.2235 2 8.84196 1.84197 8.56066 1.56066L7.93934 0.93934C7.65804 0.658035 7.2765 0.5 6.87868 0.5H5.12132C4.7235 0.5 4.34197 0.658035 4.06066 0.939339L3.43934 1.56066C3.15804 1.84196 2.7765 2 2.37868 2H1.5Z",
    fill: "#2FB672"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.25C4.96447 7.25 4.125 6.41053 4.125 5.375C4.125 4.33947 4.96447 3.5 6 3.5C7.03553 3.5 7.875 4.33947 7.875 5.375C7.875 6.41053 7.03553 7.25 6 7.25ZM6 8C7.44975 8 8.625 6.82475 8.625 5.375C8.625 3.92525 7.44975 2.75 6 2.75C4.55025 2.75 3.375 3.92525 3.375 5.375C3.375 6.82475 4.55025 8 6 8Z",
    fill: "#2FB672"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 3.875C2.25 4.08211 2.08211 4.25 1.875 4.25C1.66789 4.25 1.5 4.08211 1.5 3.875C1.5 3.66789 1.66789 3.5 1.875 3.5C2.08211 3.5 2.25 3.66789 2.25 3.875Z",
    fill: "#2FB672"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryicon);
export default __webpack_public_path__ + "static/media/galleryicon.2a6f3c4ff8975c90b24c759936b98cae.svg";
export { ForwardRef as ReactComponent };